import React, { Component } from 'react';
import store from '../../store';
//import { Calendar, DatePicker } from 'react-persian-datepicker';
import moment from 'moment-jalaali'
import DatePicker from 'react-datepicker2';
import Select from 'react-select';
import { HandleSubmit } from '../../func/HandleSubmit';
import ProgressDetailView from '../Progress/ProgressDetailView';
import ReactTable from 'react-table-6'
import "react-table-6/react-table.css";
const StatusNum = {
    prepishfactor: 5,
    pishfactor: 10,
    factor: 20,
    tahvil: 30,
    preafzayesh: 55,
    laghv: 40,
    afzayesh: 60,
}
function NextProgressFunc(progress) {
    switch (progress) {
        case StatusNum.preafzayesh:
            return StatusNum.afzayesh;
        case StatusNum.prepishfactor:
            return StatusNum.pishfactor;
        case StatusNum.factor:
            return StatusNum.tahvil;
    }
}
let AnbarName = [];
let ProductName = [];

class NewRequest extends Component {
    RefProductNameLabel = [];
    constructor(props) {

        super(props);
        this.state = {
            Loading: true,
            TaLoading: false,
            Action: "confirm",
            Request_code: "",
            RestForm: false,
            Anbar: [],
            Products: [],
            TableData: [],
            SendParameters: { comment: { desc: "" } },
            Progress: this.props.progress,
            DateNowValue: null
        };
        this.GetKalaName = this.GetKalaName.bind(this);
        this.renderSelectEditable = this.renderSelectEditable.bind(this);
        this.renderQtyEditable = this.renderQtyEditable.bind(this);
        this.keydownHandler = this.keydownHandler.bind(this);
        this.AddRow = this.AddRow.bind(this);
        this.RemRow = this.RemRow.bind(this);
        this.HandleRegister = this.HandleRegister.bind(this);
    }
    ValidatingForm() {
        if (this.state.TableData.length < 1)
            return false;
        const re = /^[0-9\b]+$/;
        for (let item of this.state.TableData) {
            if (item['anbar_code'].trim() == "" && this.state.Progress == StatusNum.preafzayesh)
                return false;
            if (item['kala_code'].trim() == "")
                return false;
            if (re.test(item['qty_value'].trim()) == false)
                return false;
        }
        return true;
    }
    async HandleRegister() {
        // this.state.SendParameters['request_code'] = this.props.request_code;
        if (this.ValidatingForm() == false)
            return false;
        this.state.SendParameters['progress'] = this.props.progress;
        this.state.SendParameters['action'] = "confirm";
        this.state.SendParameters['detail'] = this.state.TableData;
        this.setState({
            Loading: true,
            SendParameters: this.state.SendParameters
        });

        let url = 'confirm/confirmrequest';
        var response_info = await HandleSubmit(url, this.state.SendParameters);
        if (response_info.status === "OK" && response_info.request_code > 0) {
            this.setState({
                Loading: false,
                Request_code: response_info.request_code,
                Action: "view",
                //Progress: NextProgressFunc(this.state.Progress)


            });
        }
        else if (response_info.status === "InvError") {
            alert("مشکل در موجودی");
        }
        else {
            alert("مشکل در ثبت");
        }
    }
    showMessage() {
        alert('SOME MESSAGE');
    }
    keydownHandler(e) {
        if (e.keyCode === 13 && e.ctrlKey) {
            this.AddRow()
            this.RefProductNameLabel[this.RefProductNameLabel.length - 1].focus();
            //this.RefProductNameLabel[this.RefProductNameLabel.length - 1].scrollIntoView({ blok: "start", behavior: "smooth" });
            window.scrollTo(0, 10000)
        }
    }
    async componentDidMount() {
        if (this.props.progress == StatusNum.preafzayesh)
            store.dispatch({ type: 'increquest' });
        if (this.props.progress == StatusNum.prepishfactor)
            store.dispatch({ type: 'newrequest' });
        console.log(store.getState());
        this.setState({
            Loading: true,
            // 
        });
        document.addEventListener('keydown', this.keydownHandler);
        await this.GetKalaName();
        await this.GetAnbarName();
        this.AddRow();
        this.setState({
            Loading: false,
            // DateNowValue: moment()
        });
        //console.log("momoent", moment());
    }
    async componentWillUnmount() {
        document.removeEventListener('keydown', this.keydownHandler);
    }
    AddRow() {
        const row = {
            anbar_code: AnbarName[0].value, anbar_name: AnbarName[0].label, kala_code: "",
            kala_inventory: "", kala_name: "", qty_value: "", row: this.state.TableData.length
        };
        this.state.TableData.push(row);
        this.setState({ TableData: this.state.TableData });
    }
    async RemRow(index) {
        this.state.TableData.splice(index, 1);
        this.setState({ TableData: this.state.TableData });
        this.RefProductNameLabel.splice(index, 1);
    }
    async GetKalaName() {
        var response_info = await HandleSubmit('getdata/getkalaname', '');
        ProductName = response_info;
    }
    async GetAnbarName() {
        var response_info = await HandleSubmit('getdata/getanbarname', '');
        console.log(response_info);
        AnbarName = response_info;
    }
    handleInputChange = (cellInfo, event) => {
        this.state.TableData[cellInfo.index][cellInfo.column.id] = event.target.value;
        this.setState({ TableData: this.state.TableData });
        //console.log("thistail", this.state.TableData);
    }
    handleSelectChange = (cellInfo, value, col_name) => {
        this.state.TableData[cellInfo.index][cellInfo.column.id] = value.label;
        this.state.TableData[cellInfo.index][col_name] = value.value;
        this.setState({ TableData: this.state.TableData });
        //console.log("this.state.SendParameters.detail", this.state.TableData);
    }
    renderQtyEditable = cellInfo => {
        let cellValue = this.state.TableData[cellInfo.index][cellInfo.column.id];
        const re = /^[0-9\b]+$/;
        let ErrorMsg = ((cellValue.trim()) == "" || re.test(cellValue.trim()) == false) ? "باید عدد باشد" : "";
        return (
            <React.Fragment>
                <input
                    placeholder="عدد وارد کنید"
                    name="input"
                    type="text"
                    onChange={(e) => this.handleInputChange(cellInfo, e)}
                    value={cellValue.trim()}
                /><br />
                <span>{ErrorMsg}</span>
            </React.Fragment>
        );
    }
    renderSelectEditable = (options, cellInfo, col_name) => {
        const cellLabel = this.state.TableData[cellInfo.index][cellInfo.column.id];
        const cellValue = this.state.TableData[cellInfo.index][col_name];
        let ErrorMsg = ((cellLabel.trim()) == "") ? "نباید خالی باشد" : "";
        //let ErrorMsg = ((cellLabel.trim()) == "" && col_name != "anbar_code") ? "نباید خالی باشد" : "";
        return (
            <React.Fragment>
                <Select
                    isSearchable={col_name == "kala_code" ? true : false}
                    value={{ label: cellLabel, value: cellValue }}
                    options={options}
                    styles={{ menu: base => ({ ...base, position: 'relative' }) }}
                    onChange={(value) => this.handleSelectChange(cellInfo, value, col_name)}
                    ref={col_name == "kala_code" ? (ref) => (this.RefProductNameLabel[cellInfo.index] = ref) : null}
                />
                <span>{ErrorMsg}</span>
            </React.Fragment>
        );
    };
    render() {
        //console.log(this.state.SendParameters.detail);
        if (this.state.Loading) { return "در حال بارگزاری..."; }
        if (this.state.Action === "view") {
            return <ProgressDetailView progress={NextProgressFunc(this.props.progress)} request_code={this.state.Request_code} />
        }
        let showAnbar = false;
        switch (this.state.Action) {
            case "edit":
                showAnbar = (this.props.progress != StatusNum.afzayesh && this.props.progress != StatusNum.tahvil) ? false : true;
                break;
            case "confirm":
                showAnbar = (NextProgressFunc(this.props.progress) != StatusNum.afzayesh) ? false : true;
                //console.log("(NextProgressFunc(this.props.progress)", NextProgressFunc(this.props.progress));
                break;
        }
        return (
            <div>
                <React.Fragment>
                    {/* <DatePicker
                    onChange={value => this.setState({ DateNowValue: value })}
                    value={this.state.DateNowValue}
                /> */}
                    <ReactTable
                        className="-striped -highlight"
                        showPagination={false}
                        minRows={0}
                        defaultPageSize={100}
                        headerStyle={{ fontWeight: "bold", fontcolor: "red" }}
                        data={this.state.TableData}
                        loading={this.state.TaLoading}
                        NoDataComponent={CustomNoDataComponent}
                        columns={[
                            {
                                Header: "#",
                                accessor: "row",
                                maxWidth: 100,
                                minWidth: 20,
                                Cell: (row) => (row.value + 1)
                            },
                            {
                                Header: () => <div style={{ fontWeight: "bold" }}> نام کالا </div>,
                                accessor: "kala_name",
                                maxWidth: 400,
                                minWidth: 200,
                                Cell: (row) => this.renderSelectEditable(ProductName, row, 'kala_code'),
                                style: { overflow: 'visible' },
                            },
                            {
                                Header: () => <div style={{ fontWeight: "bold" }}>تعداد </div>,
                                accessor: "qty_value",
                                Cell: (cellinfo) => this.renderQtyEditable(cellinfo),
                            },
                            {
                                Header: () => <div style={{ fontWeight: "bold" }}>انبار </div>,
                                accessor: "anbar_name",
                                maxWidth: 250,
                                minWidth: 200,
                                Cell: (row) => this.renderSelectEditable(AnbarName, row, 'anbar_code'),
                                style: { overflow: 'visible' },
                                show: showAnbar,
                            },
                            {
                                Header: () => <div style={{ fontWeight: "bold" }}># </div>,
                                accessor: "",
                                Cell: (cellinfo) => <button className="btn btn-outline-danger" onClick={() => this.RemRow(cellinfo.index)}>حذف</button>
                            },


                        ]}
                        className="-striped -highlight"
                    />

                </React.Fragment>
                <br />

                {(this.state.Loading) ? null :
                    <React.Fragment>
                        <table>
                            <tr>
                                <td>
                                    <div>

                                    </div>
                                </td>
                            </tr>
                            <tr><td>
                                <button className="btn btn-success" onClick={() => this.AddRow()}>+</button>
                            </td><td>
                                    <button className="btn btn-success" onClick={() => this.HandleRegister()}>ثبت</button>
                                </td>
                            </tr>
                            <tr >
                                <td style={{ "textAlign": "left" }}>توضیحات</td>
                                <td colSpan="2" style={{ "textAlign": "right" }}>
                                    <textarea rows="3" cols="30" name="description"
                                        onChange={(e) => (
                                            this.state.SendParameters['comment']['desc'] = e.target.value,
                                            this.setState(
                                                {
                                                    SendParameters: this.state.SendParameters
                                                }
                                            ))}
                                    defaultValue={this.state.SendParameters['comment']['desc']}
                                    />
                                </td>
                            </tr>
                        </table>
                    </React.Fragment>}
            </div >
        );
    }

}
export default (NewRequest);

function CustomNoDataComponent({ state, ...rest }) {
    // if (state.isLoading) {
    //   return null;
    // }validForm = (ErrorMsg != "") ? false : true;
    return <div className="rt-noData"><br /><br />هیچ ردیفی انتخاب نشده است</div>
}



// WEBPACK FOOTER //
// ./src/pages/Request/NewRequest.js